const EmptyState = variants => {
  const defaultText = 'Sem resultados...';
  const defaultComponent = <div className="spinner-border m-5" role="status" />;

  return variants ? defaultText : defaultComponent;
};

export default EmptyState;
